///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.reporting = modules.ribit.reporting || {};
modules.ribit.reporting.plugins = modules.ribit.reporting.plugins || {};
modules.ribit.reporting.plugins.select2 = modules.ribit.reporting.plugins.select2 || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.reporting.plugins.select2 = {
    current_field: null,
    current_val: [],

    /**
     * Configure the rule's display and behavior
     */
    initRule: function (rule) {
        const fieldId = rule.$el.find('.rule-value-container select').data('select2-id');

        // Add a "View All" option to the btn-group in the query builder
        const modelLink = '<a href="#" class="filter-model btn btn-sm btn-success plugin-btn" data-bs-toggle="modal" data-toggle="modal" data-bs-target="#filter-modal" data-target="#filter-modal" data-column="' + rule.filter.field + '" data-label="' + rule.filter.label + '" data-field="' + fieldId + '" title="View All ' + rule.filter.label + '...">' +
            '<i class="fa-solid fa-magnifying-glass"></i>' +
        '</a>';

        rule.$el.find('.rule-header .btn-group').prepend(modelLink);
    },

    /**
     * Configure the select2 plugin for use with the query builder
     *
     * @param {*} plugin
     */
    initPlugin: function (plugin) {
        plugin.plugin_config.ajax = {
            cache: true,
            dataType: 'json',
            delay: 1250,
            url: function () {
                // Limit filter modal results to own items and/or competitor items
                const ownItems = $('#own_items_own_items').is(':checked') ? 1 : 0;
                const competitorItems = $('#competitor_items_competitor_items').is(':checked') ? 1 : 0;

                return '/truvu/reporting/values/' + modules.ribit.reporting.common.report_id + '/' + plugin.plugin_config.column +
                    '?own_items=' + ownItems +
                    '&competitor_items=' + competitorItems;
            },
            data: function (params) {
                return {
                    q: params.term,
                    //page: params.page || 1
                };
            },

            processResults: function (data) {
                $.each(data, function (i, d) {
                    // Allow for blank/separator values
                    data[i]['id'] = d.id == '' ? d.blank_value : d.id;
                });

                return {
                    results: data
                };
            },

            success: function () {
                // Add a "View All" option to the select2 dropdown
                modules.ribit.reporting.plugins.select2.addViewAllOption(plugin.plugin_config.column, plugin.label);
            },
        };

        // Format the CustomUpload Select2 dropdown options
        plugin.plugin_config.templateResult = function (data) {
            if (data.id && data.id.indexOf('customupload:') === 0) {
                return $('<div class="customupload"><i class="fa-duotone fa-solid fa-cloud-arrow-up mr-1 me-1"></i>' + data.text + '</div>');
            } else {
                return data.text;
            }
        };

        // Set the value(s) in the select2 dropdown
        plugin.valueSetter = function (rule, value) {
            const field = rule.$el.find('.rule-value-container select');

            // Add the value(s) to the select2 dropdown if they don't exist
            // Would've thought select2 would handle this, but it doesn't
            value.forEach(function(val) {
                if (!field.find('option[value="' + val + '"]').length) {
                    field.append($('<option>').text(val));
                }
            });

            field.val(value).trigger("change");
        };

        // Get and format the value(s) from the select2 dropdown
        plugin.valueGetter = function (rule) {
            return rule.$el.find('.rule-value-container select').val();
        };
    },

    /**
     * Add a "View All" option to the select2 dropdown
     */
    addViewAllOption: function (column, label) {
        if ($('.select2-dropdown:visible ul').length) {
            setTimeout(function() {
                // Get the select2 field ID by the dropdown result and container divs
                let fieldId = $('.select2-dropdown:visible ul').attr('id').replace('-results', '-container');
                fieldId = $('#' + fieldId).closest('.rule-value-container').find('select').data('select2-id');

                // Remove the "View All" and separators from the select2 dropdown
                $('.select2-dropdown:visible ul').find('li.view-all, li.separator').remove();

                // Add a "View All" option to the select2 dropdown
                $('.select2-dropdown:visible ul').append('<li class="separator border-top my-2"></li>' +
                    '<li class="view-all text-right text-end pb-2 px-2" role="option" aria-selected="false">' +
                        '<a href="#" data-bs-toggle="modal" data-toggle="modal" data-bs-target="#filter-modal" data-target="#filter-modal" data-column="' + column + '" data-label="' + label + '" data-field="' + fieldId + '">View All...</a>' +
                    '</li>');

                // Add a separator to the select2 dropdown after the CustomUpload options
                $('.select2-dropdown:visible ul li div.customupload:last').parent().after('<li class="separator border-top my-2"></li>');
            }, 50);
        }
    },
};
